import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
export var EMAIL_FIELD = {
  field: {
    label: 'Email',
    description: 'Чтобы мы смогли вам ответить',
    name: EFormFieldsNames.Email,
    type: EExtendedFieldTypes.InputField,
    required: true
  },
  validation: yup.string().required('Введите email').email('Неверный email адрес')
};